import React, { useEffect,useRef, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, IconButton, Container, Box, Typography, LinearProgress, InputAdornment, TextField } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CancelIcon from '@mui/icons-material/Cancel';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import CloseIcon from "@mui/icons-material/Close";
import apiClient from "../api/apiClient";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { THSarabun } from "./THSarabunNew"; 
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ClearIcon from '@mui/icons-material/Clear';
import Autocomplete from '@mui/material/Autocomplete';
import { styled } from '@mui/system';



const Report03 = () => {  
  const [dataTtb, setDataTtb] = useState([]);
  
  
  const [, forceUpdate] = useState(0);

  const [openDialog, setOpenDialog] = useState(false); // การแสดง Dialog
  const [dialogMessage, setDialogMessage] = useState(""); // ข้อความที่จะแสดงใน Dialog
  const [dialogTitle, setDialogTitle] = useState("Information"); // ค่าเริ่มต้นเป็น Error
  const [dialogTitleColor, setDialogTitleColor] = useState("black"); 
  const [dialogButtonText, setDialogButtonText] = useState("Close"); // ข้อความปุ่มเริ่มต้นเป็น Close
  const [dialogButtonTextColor, setDialogButtonTextColor] = useState("black"); 
  const [dialogButtonColor, setDialogButtonColor] = useState("white"); 
  const [dialogButtonColorh, setDialogButtonColorh] = useState("white"); 
  const fileInputRef = useRef(null);
  const token = localStorage.getItem("token");

  const [progress, setProgress] = useState(0); // To track the loading progress
  const [loading, setLoading] = useState(true); // To show loading spinner

  
  

  // const [files, setFiles] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [accountValue, setAccountValue] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [arValue, setArValue] = useState([]);
  const [selectedArs, setSelectedArs] = useState([]);
  const [apValue, setApValue] = useState([]);
  const [selectedAps, setSelectedAps] = useState([]);
  const [statusValue, setStatusValue] = useState([]);
  const inputRefs = useRef({}); 
  const [error, setError] = useState(false);
  const [accountError, setAccountError] = useState(false);

  const [depositValue, setDepositValue] = useState("");
  const [withdrawalValue, setWithdrawalValue] = useState("");


    const fetchBankData = async () => {
      try {      
        setLoading(true);
        setProgress(0); // Reset progress when fetching starts
        //Get Bank Acc
        const response = await apiClient.get("/api-data/master-accshort", {
          headers: {
            'x-screen': 'fillbankstatement',  
            "Authorization": `Bearer ${token}` ,
          },
        });

        if (response.data.s=='0' && response.data.d.rowCount > 0) {
          const files = response.data.d.rows;
          const filesTable = files.map(file => ({
            bankname: file.c11,
            account: file.c2,
            type: file.c12
          }));
  
          setAccountValue(filesTable);
        }

        //Get AR
        const responsear = await apiClient.get("/api-data/master-ar", {
            params: { screen: "Report03" },
            headers: { "Authorization": `Bearer ${token}` }
        });

        if (responsear.data.s=='0' && responsear.data.d.rowCount > 0) {
          const files = responsear.data.d.rows;
          const filesTable = files.map(file => ({
            name: file.c1,
            id: file.c2
          }));

          setArValue(filesTable);
        }

        //Get AP
        const responseap = await apiClient.get("/api-data/master-ap", {
            params: { screen: "Report03" },
            headers: { "Authorization": `Bearer ${token}` }
        });
        if (responseap.data.s=='0' && responseap.data.d.rowCount > 0) {
          const files = responseap.data.d.rows;
          const filesTable = files.map(file => ({
            name: file.c1,
            id: file.c2
          }));

          setApValue(filesTable);
        }


        setLoading(false); // Data loaded, hide progress bar
        setProgress(100); // Set progress to 100%
  
      } catch (error) {
        // console.error("Failed to fetch file list", error);
        setLoading(false); // Hide loading in case of error
      }
    };

  useEffect(() => {
    fetchBankData();
  }, []);

  const fetchReportData = async () => {
    try {  

        if (selectedAccounts.length === 0) {
          setAccountError(true);
          return;
        }
        if (!startDate) {
          setError(true);
          return;
        }
        // ถ้าผ่านหมด
        setAccountError(false);
        setError(false);

        setLoading(true);
        setProgress(0);
        setDataTtb([]); 
        inputRefs.current = {}; // ล้างข้อมูลที่ user เคยกรอกไว้

        //Get banktransaction
        const dataToSend = {
          screen: "a0032",
          startdate: dayjs(startDate).format('YYYY-MM-DD'),
          enddate: dayjs(endDate).format('YYYY-MM-DD'),
          accounts: selectedAccounts?.length ? selectedAccounts.map(item => item.account) : null,
          ars: selectedArs?.length ? selectedArs.map(item => item.id) : null,
          aps: selectedAps?.length ? selectedAps.map(item => item.id) : null,
          deposit: depositValue?depositValue : null,
          withdrawal: withdrawalValue?withdrawalValue : null
        };

        const response = await apiClient.get("/api-data/a0023", {
          headers: { Authorization: `Bearer ${token}` },
          params: dataToSend  // ส่งข้อมูลเป็น query params
        });


        // const response = await apiClient.get("/api-data/banktransaction-verify", {
        //     params: { screen: "Report03" },
        //     headers: { "Authorization": `Bearer ${token}` }
        // });

        if (response.data.banktransaction && response.data.banktransaction.rowCount > 0) {
            const rows = response.data.banktransaction.rows.map((row, idx) => ({
              ...row,
              b1: `${idx}_${row.a1}`,
              b2: `${idx}`,
              c1: `0`,
            }));
            setDataTtb(rows);

             //Get Status
              const responsest = await apiClient.get("/api-data/master-status", {
                  params: { screen: "Report03" },
                  headers: { "Authorization": `Bearer ${token}` }
              });
              if (responsest.data.master) {
                const files = responsest.data.master;
                const filesTable = files.map(file => ({
                  name: file.name,
                  id: file.id
                }));

                setStatusValue(filesTable);              
                
              } else {
                  // console.error("No Status data found");
              }

        } else {
            openDialogWithMessage("ไม่พบข้อมูล กรุณาค้นหาข้อมูลใหม่อีกครั้ง", "Warning", "#ffa000", "OK", "white", "#ffb300", "#ff6f00");
            // console.error("No bank transaction data found");
        }

        
        // console.log(dataTtb);

        setLoading(false); // Data loaded, hide progress bar
        setProgress(100); // Set progress to 100%

    } catch (error) {
      // console.error("Failed to fetch file list", error);
      setLoading(false); // Hide loading in case of error
      setProgress(100);
      return null;
    } 

  };


  const handleChange = (id, field, value) => {
    if (!inputRefs.current[id]) {
      inputRefs.current[id] = {};
    } 
    inputRefs.current[id][field] = value;
    // trigger render ใหม่แค่บางจุด
    forceUpdate((n) => n + 1);
  };

// Save ทั้งหมดพร้อม update state
  const handleSave = async () => {
    const updatedData = dataTtb.map((row) => {
      const updated = inputRefs.current[row.b1] || {};
      return {
        ...row,
        a4: 'a4' in updated ? updated.a4 : row.a4,
        a6: 'a6' in updated ? updated.a6 : row.a6,        
        a10: 'a10' in updated ? (updated.a10 ?? null) : row.a10,
        a11: 'a11' in updated ? (updated.a11 ?? null) : row.a11,
        c1: 'c1' in updated ? (updated.c1 ?? null) : row.c1,
      };
    });

    // console.log("ข้อมูลที่บันทึก:", updatedData);
    setDataTtb(updatedData);

    const d = {
      s: "a0032",       
      d: updatedData,
      startdate: dayjs(startDate).format('YYYY-MM-DD'),
      enddate: dayjs(endDate).format('YYYY-MM-DD'),
      accounts: selectedAccounts?.length ? selectedAccounts.map(item => item.account) : null,
      ars: selectedArs?.length ? selectedArs.map(item => item.id) : null,
      aps: selectedAps?.length ? selectedAps.map(item => item.id) : null     
    };

    // console.log(JSON.stringify(dataToSend).length);

    try {
      const response = await apiClient.post("/api-data/a0024", d, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.status === 200) {
        if (response.data.status === 'INSERT_SUCCESSFUL') {
          openDialogWithMessage(response.data.message, "Save Complete", "#519a39", "OK", "white", "#66bb49", "#3f762c");
          setDataTtb([]); // ล้าง rows
          inputRefs.current = {}; // ล้างข้อมูลที่ user เคยกรอกไว้
        } else {
          openDialogWithMessage("Unexpected result", "Warning", "#ffa000", "OK", "white", "#ffb300", "#ff6f00");
        }
      }
      
    } catch (error) {
      // console.error("API Error:", error);
      openDialogWithMessage(error.response?.data?.error || "Failed to save data.", "Save Failed", "#e40000", "Close", "white", "#ff1616", "#d40000");
    }
  };

  // EditableCell Component ภายในไฟล์นี้เลย
  function EditableCell({ value, onSave }) {
    const [inputValue, setInputValue] = React.useState(value);

    React.useEffect(() => {
      setInputValue(value);
    }, [value]);

    const handleChange = (e) => {
      setInputValue(e.target.value);
    };

    const handleBlur = () => {
      onSave(inputValue);
    };

    return (
      <TextField
        variant="standard"
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        fullWidth
        size="small"
      />
    );
  }


  // EditableAutocomplete Component (memoized)
const EditableAutocomplete = React.memo(({ value, options, onSave }) => {
    const [inputValue, setInputValue] = React.useState("");
    const [selectedOption, setSelectedOption] = React.useState(null);

    React.useEffect(() => {
      const found = options.find((opt) => opt.id === value);
      setSelectedOption(found || null);
      setInputValue(found ? `${found.id} - ${found.name}` : "");
    }, [value, options]);

    return (
      <Autocomplete
        options={options}
        getOptionLabel={(option) => `${option.id} - ${option.name}`}
        value={selectedOption}
        inputValue={inputValue}
        onChange={(event, newValue) => {
          setSelectedOption(newValue);
          onSave(newValue ? newValue.id : "");
        }}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === "input") setInputValue(newInputValue);
        }}
        renderInput={(params) => <TextField {...params} variant="standard" size="small" />}
        freeSolo={false}
        disableClearable
        isOptionEqualToValue={(option, val) => option.id === val.id}
      />
    );
  });








 

  // ฟังก์ชันกำหนดข้อความของสถานะ
const getStatusLabel = (match) => {
    if (match?.includes("Y_")) return "Match";
    if (match?.includes("C_")) return "Confirm";
    if (match?.includes("D_")) return "Check";
    return "Not Match";
  };
  
  // ฟังก์ชันกำหนดสีของ cell
  const getColorByMatch = (match) => {
    if (match?.includes("Y_")) return "09D146"; // สีเขียว
    if (match?.includes("C_")) return "007EF6"; // สีฟ้า
    if (match?.includes("D_")) return "FEDA00"; // สีเหลือง
    return "E65151"; // สีแดง
  };
  

  const openDialogWithMessage = (message, title = "Information", titleColor = "black", buttonText = "Close", buttonTextColor = "black", buttonColor = "white", buttonColorh = "white") => {
    setDialogMessage(message);
    setDialogTitle(title);
    setDialogTitleColor(titleColor);
    setDialogButtonText(buttonText);
    setDialogButtonTextColor(buttonTextColor);
    setDialogButtonColor(buttonColor);
    setDialogButtonColorh(buttonColorh);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <Container component="main" maxWidth="96%" sx={{marginTop: "40px",border: "0px solid #e0e0e0",boxSizing: "border-box",}}>

      {/* Loading Progress Bar */}
      {loading ? (
        <Box sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          zIndex: 999,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}>
          <LinearProgress variant="determinate" value={progress} sx={{ width: '50%' }} />
        </Box>

       ) : ( 

      <Box sx={{ width: '100%',display: "flex",flexDirection: "column", marginLeft:0, marginBottom:0, boxShadow: "none",marginTop: "0px",border: "0px solid #e0e0e0" ,boxSizing: "border-box",
        backgroundColor: "background.paper",
      }}>

        <Box sx={{ borderRadius: 0,boxSizing: "border-box",marginBottom:"4px", boxShadow: "none",marginTop: "0px",
          textAlign: "center",
          verticalAlign: "middle",
          padding:1,
          backgroundColor: "#f5f5f5",
          fontSize: "calc(14px + 0.5vw)",
          fontWeight: "bold",
          color: "#333",
          width: '100%'
        }}>
          รีวิวรายการเดินบัญชีจากธนาคาร (Bank Statement) - เลือกลูกหนี้หรือเจ้าหนี้
        </Box>

        <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "4px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
                        borderRadius: 0,textAlign: "center",verticalAlign: "middle",fontSize: "calc(14px - 0.01vw)",padding:1,
                        display: "flex",            // ✅ เพิ่ม
                        justifyContent: "center",   // ✅ จัดให้อยู่ตรงกลางแนวนอน
                        alignItems: "center",
                        gap: 2, flexWrap: "wrap",
                      }}>

              <Autocomplete
                  multiple
                  options={accountValue}
                  getOptionLabel={(option) =>
                    `${option.bankname} - ${option.account} (${option.type})`
                  }
                  value={selectedAccounts}
                  // onChange={(event, newValue) => setSelectedAccounts(newValue)}
                  onChange={(event, newValue) => {
                    setSelectedAccounts(newValue);
                    setAccountError(false);  // ล้าง error เมื่อเปลี่ยนค่า
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="เลือกบัญชีธนาคาร" placeholder="เลือกได้หลายบัญชี" style={{ width: 300}} size="small" id="account"  required
                      error={accountError}
                      helperText={accountError ? "กรุณาเลือกอย่างน้อย 1 บัญชี" : ""}
                      // sx={{
                      //     fontSize: 11,
                      //     '& .MuiChip-label': {
                      //       fontSize: 10,
                      //     },
                      //   }}
                    />
                  )}
                  PaperComponent={(props) => (
                    <Paper
                      {...props}
                      // sx={{
                      //   fontSize: 11,
                      //   '& .MuiAutocomplete-listbox': {
                      //     fontSize: 11,
                      //     padding: 0,
                      //   },
                      //   '& .MuiAutocomplete-option': {
                      //     fontSize: 11,
                      //     paddingTop: 4,
                      //     paddingBottom: 4,
                      //   },
                      // }}
                    />
                  )}
                />

                
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                {/* <Box sx={{ display: 'flex',flexDirection: "column", gap: 2, alignItems: 'center',boxSizing: "border-box" }}> */}
                  
                  {/* <Typography variant="body2" sx={{ marginBottom:0, boxShadow: "none",marginTop: "0px",
                    textAlign: "center",
                    verticalAlign: "middle",
                    padding:1,
                    fontSize: "calc(14px + 0.2vw)",
                    // fontWeight: "bold",
                    color: "#333",
                  }}>
                    เลือกวันที่ของข้อมูลธนาคาร
                  </Typography> */}

                  <DatePicker label="เลือกวันที่เริ่มต้น*"
                              value={startDate}
                              onChange={(newValue) => {
                                setStartDate(newValue);
                                setError(false);
                                // ถ้าเปลี่ยน startDate ใหม่ และ endDate น้อยกว่า startDate ให้ reset endDate
                                if (endDate && newValue && endDate < newValue) {
                                  setEndDate(null);
                                }
                              }}
                              // onChange={(newValue) => setStartDate(newValue)}
                              sx={{ width: 190 }}
                              slotProps={{
                                field: { clearable: true, onClear: () => setStartDate(null) },
                                textField: { 
                                  size: 'small',
                                  placeholder: 'Select Date',
                                  error: error,
                                  helperText: error && !startDate ? 'กรุณาเลือกวัน' : '',
                                },
                              }}
                              
                            />

                  <DatePicker label="เลือกวันที่สิ้นสุด"
                              value={endDate}
                              onChange={(newValue) => setEndDate(newValue)}
                              disabled={!startDate}  // <-- ถ้า startDate ยังไม่เลือก disable ไว้
                              minDate={startDate}     // <-- กำหนดวันที่น้อยสุดของ endDate เป็น startDate
                              sx={{ width: 190 }}
                              slotProps={{
                                field: { clearable: true, onClear: () => setEndDate(null) },
                                textField: { size: 'small',placeholder: 'Select End Date'},
                              }}
                              
                            />

                  
                {/* </Box> */}
              </LocalizationProvider>

               


                <Autocomplete
                  multiple
                  options={arValue}
                  getOptionLabel={(option) =>
                    `${option.name} (${option.id})`
                  }
                  value={selectedArs}
                  onChange={(event, newValue) => setSelectedArs(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} label="เลือกลูกหนี้" placeholder="เลือกได้หลายบัญชี" style={{ width: 300}} size="small" id="ar" 
                      // sx={{
                      //     fontSize: 11,
                      //     '& .MuiChip-label': {
                      //       fontSize: 10,
                      //     },
                      //   }}
                    />
                  )}
                  PaperComponent={(props) => (
                    <Paper
                      {...props}
                      // sx={{
                      //   fontSize: 11,
                      //   '& .MuiAutocomplete-listbox': {
                      //     fontSize: 11,
                      //     padding: 0,
                      //   },
                      //   '& .MuiAutocomplete-option': {
                      //     fontSize: 11,
                      //     paddingTop: 4,
                      //     paddingBottom: 4,
                      //   },
                      // }}
                    />
                  )}
                />


                <Autocomplete
                  multiple
                  options={apValue}
                  getOptionLabel={(option) =>
                    `${option.name} (${option.id})`
                  }
                  value={selectedAps}
                  onChange={(event, newValue) => setSelectedAps(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} label="เลือกเจ้าหนี้" placeholder="เลือกได้หลายบัญชี" style={{ width: 300}} size="small" id="ap" 
                      // sx={{
                      //     fontSize: 11,
                      //     '& .MuiChip-label': {
                      //       fontSize: 10,
                      //     },
                      //   }}
                    />
                  )}
                  PaperComponent={(props) => (
                    <Paper
                      {...props}
                      // sx={{
                      //   fontSize: 11,
                      //   '& .MuiAutocomplete-listbox': {
                      //     fontSize: 11,
                      //     padding: 0,
                      //   },
                      //   '& .MuiAutocomplete-option': {
                      //     fontSize: 11,
                      //     paddingTop: 4,
                      //     paddingBottom: 4,
                      //   },
                      // }}
                    />
                  )}
                />

                <TextField
                  id="Deposit"
                  name="Deposit"
                  label={`จำนวนเงินฝาก`}
                  placeholder={`Deposit`}
                  autoComplete="off"
                  variant="outlined"
                  size="small"                  
                  style={{ width: 150 }}
                  value={depositValue}
                  onChange={(e) => {
                    const value = e.target.value;
                    const regex = /^\d*\.?\d{0,2}$/;
                    if (value === "" || regex.test(value)) {
                      setDepositValue(value);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  inputProps={{
                    inputMode: "decimal",
                    pattern: "[0-9.]*"
                  }}
                  InputProps={{
                    endAdornment: depositValue ? (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="clear input"
                          size="small"
                          onClick={() => setDepositValue("")}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                />

                <TextField
                  id="Withdrawal"
                  name="Withdrawal"
                  label={`จำนวนเงินถอน`}
                  placeholder={`Withdrawal`}
                  autoComplete="off"
                  variant="outlined"
                  size="small"
                  style={{ width: 150 }}
                  value={withdrawalValue}
                  onChange={(e) => {
                    const value = e.target.value;
                    const regex = /^\d*\.?\d{0,2}$/;
                    if (value === "" || regex.test(value)) {
                      setWithdrawalValue(value);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  inputProps={{
                    inputMode: "decimal",
                    pattern: "[0-9.]*"
                  }}
                  InputProps={{
                    endAdornment: withdrawalValue ? (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="clear input"
                          size="small"
                          onClick={() => setWithdrawalValue("")}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                />

                <button
                  onClick={fetchReportData}
                  style={{
                    padding: "8px 15px",
                    background: "#0061d4",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "calc(8px + 0.5vw)",
                    marginRight: "10px",
                  }}
                >
                  แสดงข้อมูล
              </button>
  

          </Box>

        {dataTtb.length <= 0 && (
        <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "0px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
          borderRadius: 0,textAlign: "center",verticalAlign: "middle",fontSize: "calc(14px - 0.01vw)",padding:1,
        }}>
              "กรุณาคลิกแสดงข้อมูลรายการเดินบัญชีจากธนาคาร (Bank Statement) "
        </Box>
        )}
        
        {dataTtb.length > 0 && (

          <>

          <TableContainer
            component={Paper}
            sx={{
              maxHeight: 400,
              overflow: "auto", // ให้ scroll แนวตั้ง
              minWidth: 800,     // บังคับให้มี scroll แนวนอนถ้าเนื้อหากว้าง
            }}
          >
            <Table size="small" aria-label="a dense table" sx={{ borderCollapse: 'collapse' }}>
            <TableHead sx={{ backgroundColor: '#f5f5f5',whiteSpace: "nowrap", }}>
                <TableRow>
                  {/* <TableCell align="center">#</TableCell>
                  <TableCell align="center">เลขที่บัญชี</TableCell>                  
                  <TableCell align="center">วันที่ทำรายการ</TableCell>
                  <TableCell align="center">ฝาก</TableCell>
                  <TableCell align="center">ชื่อลูกหนี้/ผู้โอนเงิน</TableCell>
                  <TableCell align="center">ถอน</TableCell>
                  <TableCell align="center">ชื่อเจ้าหนี้/ผู้รับเงิน</TableCell>
                  <TableCell align="center">ยอดคงเหลือ</TableCell>
                  <TableCell align="center">เลขที่เช็ค</TableCell>
                  <TableCell align="center">หมายเหตุ</TableCell>
                  <TableCell align="center">เลือกสถานะเอง</TableCell>
                  <TableCell align="center">หมายเหตุสถานะ</TableCell> */}

                  {/* <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>#</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>เลขที่บัญชี</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>วันที่ทำรายการ</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>ฝาก</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>ชื่อลูกหนี้/ผู้โอนเงิน</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>ถอน</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>ชื่อเจ้าหนี้/ผู้รับเงิน</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>ยอดคงเหลือ</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>เลขที่เช็ค</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>หมายเหตุ</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>เลือกสถานะเอง</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>หมายเหตุสถานะ</TableCell> */}

                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)'}}>#</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เลขที่บัญชี</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>วันที่ทำรายการ</TableCell>
{/* Add 202609071623 from 02_Enh_QT-2026-000014 item 1.1  */}                   
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ประเภท</TableCell>
{/* End Add 202609071623 from 02_Enh_QT-2026-000014 item 1.1  */}                   
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เงินนำฝากเข้าบัญชี</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ชื่อลูกหนี้/ผู้โอนเงิน</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เงินหักบัญชี</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ชื่อเจ้าหนี้/ผู้รับเงิน</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ยอดคงเหลือ</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เลขที่เช็ค</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>หมายเหตุ</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เลือกสถานะเอง</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>หมายเหตุสถานะ</TableCell>
                  
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>สกุลเงิน</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เงินฝากต่างประเทศ</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เงินหักต่างประเทศ</TableCell>

                  {/* <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1 }}>#</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1 }}>เลขที่บัญชี</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1 }}>วันที่ทำรายการ</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1 }}>ฝาก</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1 }}>ชื่อลูกหนี้/ผู้โอนเงิน</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1 }}>ถอน</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1 }}>ชื่อเจ้าหนี้/ผู้รับเงิน</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1 }}>ยอดคงเหลือ</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1 }}>เลขที่เช็ค</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1 }}>หมายเหตุ</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1 }}>เลือกสถานะเอง</TableCell>
                  <TableCell sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1 }}>หมายเหตุสถานะ</TableCell> */}

                </TableRow>
              </TableHead>


              <TableBody>
                {dataTtb.map((file, index) => (
                  <TableRow
                    key={file.b1}
                    // sx={{ borderBottom: '1px solid rgba(0, 0, 0, 0.3)' }}
                    // sx={{ '&:last-child td, &:last-child th': { border: 0 ,whiteSpace: "nowrap", borderBottom: '1px solid rgba(0, 0, 0, 0.3)'} }}
                  >
                    <TableCell align="center" component="th" scope="row" sx={{ border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {index+1}
                    </TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.a1}</TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {new Date(file.a2).toISOString().split("T")[0]}
                    </TableCell>
{/* Add 202609071623 from 02_Enh_QT-2026-000014 item 1.1  */}                    
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.a16}</TableCell>
{/* End Add 202609071623 from 02_Enh_QT-2026-000014 item 1.1  */}                     
                    <TableCell align="right" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.a3)}
                    </TableCell>

{/* Add 202609071623 from 02_Enh_QT-2026-000014 item 1.1  */}
                    <TableCell sx={{ whiteSpace: "nowrap", minWidth: 250, border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      <Autocomplete
                        options={arValue}
                        // 🟢 เพิ่ม disabled ตรงนี้ (ถ้าค่าปัจจุบันเป็น 12 หรือ String "12" จะกดเลือกไม่ได้)
                        disabled={
                          (inputRefs.current[file.b1]?.a10 !== undefined 
                            ? inputRefs.current[file.b1]?.a10 
                            : file.a10) == 12
                        }
                        getOptionLabel={(option) => `${option.name} (${option.id})`}                      
                        value={
                          'a4' in (inputRefs.current[file.b1] || {})
                            ? arValue.find(opt => opt.id === inputRefs.current[file.b1].a4) || null
                            : arValue.find(opt => opt.id === file.a4) || null
                        }
                        onChange={(e, newValue) => {
                          handleChange(file.b1, "a4", newValue?.id || null);
                          handleChange(file.b1, "a10", newValue ? 2 : null);
                          handleChange(file.b1, "c1", 1);
                        }}
                        renderInput={(params) => <TextField {...params} variant="standard" />}
                        size="small"
                      />
                    </TableCell>

                    {/* <TableCell sx={{ whiteSpace: "nowrap", minWidth: 250, border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      <Autocomplete
                        options={arValue}
                        getOptionLabel={(option) => `${option.name} (${option.id})`}                      
                        // value={arValue.find((opt) => opt.id === (inputRefs.current[file.b1]?.c4 !== undefined 
                        //   ? inputRefs.current[file.b1]?.c4 : file.c4)) 
                        //   || null}
                        value={
                          'a4' in (inputRefs.current[file.b1] || {})
                            ? arValue.find(opt => opt.id === inputRefs.current[file.b1].a4) || null
                            : arValue.find(opt => opt.id === file.a4) || null
                        }
                        onChange={(e, newValue) => {
                          handleChange(file.b1, "a4", newValue?.id || null);
                          handleChange(file.b1, "a10", newValue ? 2 : null);
                          handleChange(file.b1, "c1", 1);
                        }}
                        renderInput={(params) => <TextField {...params} variant="standard" />}
                        size="small"
                      />
                    </TableCell> */}
{/* End Add 202609071623 from 02_Enh_QT-2026-000014 item 1.1  */}

                    <TableCell align="right" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.a5)}
                    </TableCell> 

{/* Add 202609071623 from 02_Enh_QT-2026-000014 item 1.1  */}
                    <TableCell sx={{ whiteSpace: "nowrap", minWidth: 250, border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      <Autocomplete
                        options={apValue}
                        // 🟢 ล็อกไม่ให้เลือกเมื่อ a10 มีค่าเท่ากับ 12
                        disabled={
                          (inputRefs.current[file.b1]?.a10 !== undefined 
                            ? inputRefs.current[file.b1]?.a10 
                            : file.a10) == 12
                        }
                        getOptionLabel={(option) => `${option.name} (${option.id})`}
                        value={
                          'a6' in (inputRefs.current[file.b1] || {})
                            ? apValue.find(opt => opt.id === inputRefs.current[file.b1].a6) || null
                            : apValue.find(opt => opt.id === file.a6) || null
                        }
                        onChange={(e, newValue) => {
                          handleChange(file.b1, "a6", newValue?.id || null);
                          handleChange(file.b1, "a10", newValue ? 2 : null);
                          handleChange(file.b1, "c1", 2);
                        }}
                        renderInput={(params) => <TextField {...params} variant="standard" />}
                        size="small"
                      />
                    </TableCell>

                    {/* <TableCell sx={{ whiteSpace: "nowrap", minWidth: 250, border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      <Autocomplete
                        options={apValue}
                        getOptionLabel={(option) => `${option.name} (${option.id})`}
                        // value={apValue.find((opt) => opt.id === (inputRefs.current[file.b1]?.c6 !== undefined 
                        //   ? inputRefs.current[file.b1]?.c6 : file.c6)) 
                        //   || null}
                        value={
                          'a6' in (inputRefs.current[file.b1] || {})
                            ? apValue.find(opt => opt.id === inputRefs.current[file.b1].a6) || null
                            : apValue.find(opt => opt.id === file.a6) || null
                        }
                        onChange={(e, newValue) => {
                          handleChange(file.b1, "a6", newValue?.id || null);
                          handleChange(file.b1, "a10", newValue ? 2 : null);
                          handleChange(file.b1, "c1", 2);
                        }}
                        renderInput={(params) => <TextField {...params} variant="standard" />}
                        size="small"
                      />
                    </TableCell> */}
{/* End Add 202609071623 from 02_Enh_QT-2026-000014 item 1.1  */}

                    <TableCell align="right" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                        {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.a7)}
                    </TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>{file.a8}</TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)'}}>{file.a9}</TableCell>

                    <TableCell sx={{ whiteSpace: "nowrap", minWidth: 220, border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      <Autocomplete
                        options={statusValue}
                        getOptionLabel={(option) => `${option.name}`}
                        // getOptionLabel={(option) => `${option.id} - ${option.name}`}

                        // value={statusValue.find((opt) => opt.id == (inputRefs.current[file.b1]?.c10 != undefined 
                        //   ? inputRefs.current[file.b1]?.c10 : file.c10)) 
                        //   || null}
                        value={
                          'a10' in (inputRefs.current[file.b1] || {})
                            ? statusValue.find(opt => opt.id === inputRefs.current[file.b1].a10) || null
                            : statusValue.find(opt => opt.id == file.a10) || null
                        }
                        onChange={(e, newValue) => {
                          handleChange(file.b1, "a10", newValue?.id || null);
                        }}
                        renderInput={(params) => <TextField {...params} variant="standard" />}
                        size="small"
                      />
                    </TableCell>

                    <TableCell align="left" sx={{ whiteSpace: "nowrap", minWidth: 250, border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      <TextField
                        defaultValue={file.a11 || ""}
                        variant="standard"
                        sx={{ width: "250px" }}
                        onBlur={(e) => {
                          handleChange(file.b1, "a11", e.target.value);
                        }}
                      />
                    </TableCell>

                    <TableCell align="left" sx={{whiteSpace: "pre", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.a13}</TableCell>
                    <TableCell align="right" sx={{whiteSpace: "pre", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.a14)}
                    </TableCell>
                    <TableCell align="right" sx={{whiteSpace: "pre", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                        {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.a15)}
                    </TableCell>


                  </TableRow>
                ))}
              </TableBody>


              {/* <TableBody>
                {dataTtb.map((file, index) => (
                  <TableRow
                    key={file.b1}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 ,whiteSpace: "nowrap",} }}
                  >
                    <TableCell align="center" component="th" scope="row">
                      {index+1}
                    </TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", }}>{file.accountnumber}</TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", }}>{file.date}</TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", }}>
                      {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.deposit)}
                    </TableCell>

                    <TableCell sx={{ whiteSpace: "nowrap", minWidth: 180 }}>
                      <Autocomplete
                        options={arValue}
                        getOptionLabel={(option) => `${option.id} - ${option.name}`}
                        value={arValue.find((opt) => opt.id === (inputRefs.current[file.txnId]?.arid !== undefined 
                          ? inputRefs.current[file.txnId]?.arid : file.arid)) 
                          || null}
                        onChange={(e, newValue) => {
                          handleChange(file.txnId, "arid", newValue?.id || null);
                          handleChange(file.txnId, "status", newValue ? 2 : null);
                        }}
                        renderInput={(params) => <TextField {...params} variant="standard" />}
                        size="small"
                      />
                    </TableCell>

                    <TableCell align="left" sx={{whiteSpace: "nowrap", }}>
                      {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.withdrawal)}
                    </TableCell> 

                    <TableCell sx={{ whiteSpace: "nowrap", minWidth: 180 }}>
                      <Autocomplete
                        options={apValue}
                        getOptionLabel={(option) => `${option.id} - ${option.name}`}
                        value={apValue.find((opt) => opt.id === (inputRefs.current[file.txnId]?.apid !== undefined 
                          ? inputRefs.current[file.txnId]?.apid : file.apid)) 
                          || null}
                        onChange={(e, newValue) => {
                          handleChange(file.txnId, "apid", newValue?.id || null);
                          handleChange(file.txnId, "status", newValue ? 2 : null);
                        }}
                        renderInput={(params) => <TextField {...params} variant="standard" />}
                        size="small"
                      />
                    </TableCell>


                    <TableCell align="right" sx={{whiteSpace: "nowrap", }}>
                        {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.balance)}
                    </TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", }}>{file.cheque}</TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", }}>{file.description}</TableCell>

                    <TableCell sx={{ whiteSpace: "nowrap", minWidth: 180 }}>
                      <Autocomplete
                        options={statusValue}
                        getOptionLabel={(option) => `${option.name}`}
                        // getOptionLabel={(option) => `${option.id} - ${option.name}`}
                        value={statusValue.find((opt) => opt.id === (inputRefs.current[file.txnId]?.status !== undefined 
                          ? inputRefs.current[file.txnId]?.status : file.status)) 
                          || null}
                        onChange={(e, newValue) => {
                          handleChange(file.txnId, "status", newValue?.id || null);
                        }}
                        renderInput={(params) => <TextField {...params} variant="standard" />}
                        size="small"
                      />
                    </TableCell>

                    <TableCell align="left" sx={{ whiteSpace: "nowrap", minWidth: 150 }}>
                      <TextField
                        defaultValue={""}
                        variant="standard"
                        onBlur={(e) => {
                          handleChange(file.txnId, "statusremarks", e.target.value);
                        }}
                      />
                    </TableCell>


                  </TableRow>
                ))}
              </TableBody> */}


            </Table>
          </TableContainer>

          </>
        )}
        
        {dataTtb.length > 0 && (
          <Box sx={{  marginBottom:0, boxShadow: "none",marginTop: "4px" ,boxSizing: "border-box",
            borderRadius: 0,
            padding: "4px 4px",
            textAlign: "center",
            verticalAlign: "middle",
          }}>
            {/* <button
              onClick={handleExportPDF}
              style={{
                padding: "8px 15px",
                background: "#0061d4",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: "calc(8px + 0.5vw)",
                marginRight: "10px",
              }}
              // disabled={selectedFiles.length === 0}
            >
              Export PDF
            </button> */}

            <button
              onClick={handleSave}
              style={{
                padding: "8px 15px",
                background: "#0061d4",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: "calc(8px + 0.5vw)",
              }}
            >
              บันทึกข้อมูล
            </button>
          </Box>
        )}

      </Box>

      )}


      <Dialog open={openDialog} onClose={handleCloseDialog} sx={{maxWidth: "auto",  width: "auto", margin: "auto",overflow: "visible", }}>
          <DialogTitle sx={{color: dialogTitleColor,fontSize: "1.3rem",fontWeight: "400",textAlign: "left",padding: "5px",minHeight: "30px",whiteSpace: "pre-wrap",paddingRight: "40px", }}>
          {dialogTitle} 
          </DialogTitle>
          <IconButton sx={{position: "absolute",right: "5px",top: "3px",borderRadius: "8px", }} onClick={handleCloseDialog}> 
              <CloseIcon /> 
          </IconButton>
          <DialogContent sx={{ fontSize: "1rem",maxHeight: "100%", overflowY: "auto", paddingBottom: "0",whiteSpace: "pre-wrap",wordBreak: "break-word",textAlign: "center", }}>
          {dialogMessage}
          </DialogContent>
          <DialogActions sx={{display: "flex", justifyContent: "center", alignItems: "center",marginTop: "20px",}}>
          <Button variant="contained" sx={{ backgroundColor: dialogButtonColor, color: dialogButtonTextColor, "&:hover": { backgroundColor: dialogButtonColorh } }} onClick={handleCloseDialog}>
              {dialogButtonText}
          </Button>
          </DialogActions>
      </Dialog>

    </Container>
  );
};




export default Report03;